import { SoundSwitcher } from './SoundSwitcher';

export default SoundSwitcher;
